import React, { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import axios from 'axios';
import "./etl.css";
import { Accordion } from "semantic-ui-react";
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react'

import Select, { components } from "react-select";
import { render } from "@testing-library/react";
// import Modal from 'react-modal';
import Modal from 'react-bootstrap/Modal';

import { GetProcessNames, GetIdentifierNames, Getschemaslist, Gettablelist, Getcolumnslist, Fetchexecutequery, Updatevalues } from '../../../services/process/process_data/process_data';

// const getTransformFieldList = (value) => {

//     const list = transformData.flatMap(item => {
//       const filteredRecords = item[value];
//       return filteredRecords ? filteredRecords : [];
//     });
//     return list;

//   };

const identifier = [
  { value: "string", label: "string" },
  { value: "int", label: "int" },
  { value: "special charectors", label: "special charectors" },
  { value: "contains", label: "contains" },
  { value: "starts with", label: "starts with" },
  { value: "ends with", label: "ends with" },

];

const db_list = [
  { value: "mysql", label: "mysql" },
  { value: "postgresql", label: "postgresql" },
  { value: "casendra", label: "casendra" },

];

const ValueContainer = ({ children, getValue, ...props }) => {
  let maxToShow = 1;
  var length = getValue().length;
  let displayChips = React.Children.toArray(children).slice(0, maxToShow);
  let shouldBadgeShow = length > maxToShow;
  let displayLength = length - maxToShow;

  return (
    <components.ValueContainer {...props}>
      {!props.selectProps.inputValue && displayChips}
      <div className="root">
        {/* {shouldBadgeShow &&
          `+ ${displayLength} item${length != 1 ? "s" : ""} selected`} */}
      </div>
    </components.ValueContainer>
  );
};

const KpiNew = () => {
  const [columnname, setcolumnname] = useState();
  const [rowData, setRowData] = useState([]);
  const [transformData, settransformData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedValues, setSelectedValues] = useState();

  const [selectedOptions1, setSelectedOptions1] = useState();
  const [selectedValues1, setSelectedValues1] = useState();

  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));


  const [kpiName, setKpiName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedKpiCategory, setSelectedKpiCategory] = useState('');
  const [selectedKpiType, setSelectedKpiType] = useState('');
  const [levels, setLevels] = useState('');


  // Create state variables for selected values of each Select component
  const [selectedDBs, setSelectedDBs] = useState([]);
  const [selectedSchemas, setSelectedSchemas] = useState([]);
  const [selectedTables, setSelectedTables] = useState([]);
  const [schemaslist, setschemaslist] = useState([]);
  const [tablelist, settablelist] = useState([]);
  const [columnslist, setcolumnslist] = useState([]);
  const [columnslist1, setcolumnslist1] = useState({});



  const shouldBeShown = (value) => {
    return value.data.shouldShow;
  };

  const styles = {
    option: (base, value) => {
        return (shouldBeShown(value) ?  { display: 'none'} : { ...base } );
    }
  };


  // Handle the change event for the Select components
  const handleChange11 = (event, { value }) => {
    setSelectedKpiCategory(value);
  };

  const handleChange12 = (event, { value }) => {
    setSelectedKpiType(value);
  };


  const fetchSchemaslist = (value) => {

    let name = value?.value;
    let payload = {
      'tenants': userCredentials["tenants_id"],
      'groups': userCredentials["groups_id"],
      'entities': userCredentials["entities_id"],
      'process_id': value?.value
    }

    var FileUploadCredentials = Getschemaslist();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let table_data = response.data;

          // let names = [];
          let schemasList = schemaslist;
          table_data.map((data) => {

            let obj = {
              value: name,
              label: data
            }
            schemasList.push(obj);
          })

          // schemasList.push(names);
          console.log('names', schemasList);
          setschemaslist(schemasList);
          // setSelectedOptions1(names);
        }
      )
      .catch((error) => {
        console.error("Error in POST request:", error);

        // Handle the error here, e.g., display an error message to the user or perform any necessary actions.
      });
  }

  const fetchtableslist = (value) => {

    let name = value?.value;
    let key = value?.label;
    console.log('value', value);
    let payload = {
      'tenants': userCredentials["tenants_id"],
      'groups': userCredentials["groups_id"],
      'entities': userCredentials["entities_id"],
      'database_name': value?.value,
      'schema_name': key
    }

    var FileUploadCredentials = Gettablelist();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let table_data = response.data;

          // let names = [];
          let tableList = tablelist;
          table_data.map((data) => {

            let obj = {
              value: name,
              label: data,
              key: key
            }
            tableList.push(obj);
          })

          // schemasList.push(names);
          console.log('names', tableList);
          settablelist(tableList);
          // setSelectedOptions1(names);
        }
      )
      .catch((error) => {
        console.error("Error in POST request:", error);

        // Handle the error here, e.g., display an error message to the user or perform any necessary actions.
      });
  }


  // Handle the change event for the Select components
  const handleChangeDBs = (event, { value }) => {
    console.log('value', event);
    setSelectedDBs(event);
    for (let db in event) {
      let val = event[db];
      console.log('value', val?.value);
      fetchSchemaslist(val)
    }

    // fetchSchemaslist(value);
  };

  const handleChangeSchemas = (event, { value }) => {
    setSelectedSchemas(event);
    let val = event[0];
    console.log('val', event);
    // console.log(schemaslist);
    fetchtableslist(val);
  };

  const handleChangeTables = (event, { value }) => {
    setSelectedTables(event);
  };

  // Create state variables for selected values of each Select component
  const [selectedGraphType, setSelectedGraphType] = useState('');
  const [selectedGraphParameter, setSelectedGraphParameter] = useState('');
  const [selectedgraphColumns, setSelectedgraphColumns] = useState('');

  // Handle the change event for the Select components
  const handleChangeGraphType = (event, { value }) => {
    setSelectedGraphType(value);
  };

  const handleChangeGraphParameter = (event, { value }) => {
    setSelectedGraphParameter(value);
  };

  const handleChangegraphColumns = (event, { value }) => {
    setSelectedgraphColumns(value);
  };


  // Create state variables for selected values of each Select component
  const [selectedDrilldown, setSelectedDrilldown] = useState('');
  const [selecteddrilldownTables, setSelecteddrilldownTables] = useState('');
  const [selectedColumns, setSelectedColumns] = useState('');

  // Handle the change event for the Select components
  const handleChangeDrilldown = (event, { value }) => {
    setSelectedDrilldown(value);
  };

  const handleChangedrilldownTables = (event, { value }) => {
    setSelecteddrilldownTables(value);
  };

  const handleChangeColumns = (event, { value }) => {
    setSelectedColumns(value);
  };


  const fetchcolumnslist = (value) => {

    let name = value?.label;
    let key = value?.key;
    console.log('value', value);
    let payload = {
      'tenants': userCredentials["tenants_id"],
      'groups': userCredentials["groups_id"],
      'entities': userCredentials["entities_id"],
      'database_name': value?.value,
      'schema_name': value?.key,
      'table_name': value?.label
    }

    var FileUploadCredentials = Getcolumnslist();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let table_data = response.data;

          // let names = [];
          let columnsList = [];
          table_data.map((data) => {

            let obj = {
              value: name,
              label: data,
              key: key
            }
            columnsList.push(obj);
          })

          setcolumnslist(columnsList);
          const objectLength = Object.keys(columnslist1).length;
          console.log('objectLength', objectLength);
          setcolumnslist1((prevData) => ({
            ...prevData,
            [objectLength]: columnsList,
          }));

        }
      )
      .catch((error) => {
        console.error("Error in POST request:", error);

        // Handle the error here, e.g., display an error message to the user or perform any necessary actions.
      });
  }

  const saveRow = (index, columnName, value) => {
    console.log('value', value);
    const updatedData = [...rowData];
    updatedData[index][columnName] = value;
    setRowData(updatedData);

  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log('name', e, e.target);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name == 'tables') {
      fetchcolumnslist(value)
    }

    console.log('formData', formData);
  };

  const handleAddData = () => {
    // Create a new row object based on the formData state
    const newRow = {
      tables: formData.tables,
      columns: formData.columns,
      functions: formData.functions,
      conditions: formData.conditions,

    };

    // Add the new row to the rowData state
    setRowData([...rowData, newRow]);

    // Clear the form fields
    setFormData({
      tables: '',
      columns: '',
      functions: '',
      conditions: ''

    });

    console.log('rowData', rowData);
  };

  const handleSaveData = () => {
    // settransformData(rowData);
    let newdata = {
      [columnname]: rowData,
    }
    settransformData((prevData) => ([
      ...prevData,
      newdata
    ]));

    console.log('transformData', transformData);
  }

  const fetchidentifiertypes = (value) => {


    let payload = {
      'tenants': userCredentials["tenants_id"],
      'groups': userCredentials["groups_id"],
      'entities': userCredentials["entities_id"],
      'process_id': value
    }

    var FileUploadCredentials = GetIdentifierNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let table_data = response.data;

          let names = [];
          table_data.map((data) => {

            let obj = {
              value: data.id,
              label: data.identifier_type_name
            }
            names.push(obj);
          })
          setSelectedOptions1(names);
        }
      )
  }


  const handleChange1 = (event) => {
    const newValue = event;
    console.log('selected val' + newValue);
    setSelectedValues(newValue);
    fetchidentifiertypes(newValue.value)

  }

  const handleChange2 = (event) => {
    const newValue = event;
    console.log('selected val' + newValue);
    setSelectedValues1(newValue);

  }

  const fetchprocessnames = () => {
    let payload = {
      File_data: 'hi',
    }

    var FileUploadCredentials = GetProcessNames();

    axios.post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(
        response => {
          console.log("Validate Credentials Response!!!", response);
          let table_data = response.data;

          let names = [];
          table_data.map((data) => {

            let obj = {
              value: data.process_id,
              label: data.process_name
            }
            names.push(obj);
          })
          setSelectedOptions(names);
        }
      )

  }

  const [formData, setFormData] = useState({
    tables: '',
    columns: '',
    functions: '',
    conditions: ''

  });

  useEffect(() => {
    fetchprocessnames();
  }, []);




  return (
    <>
      <Grid item style={{ backgroundColor: "#e9e8d9", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
      <div style={{width:'100%'}}>
        <h1 className=" pt-1 pb-1 text-center" style={{ color: "#4969ab"}}>KPI</h1>
      </div>
      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#e9e8d9", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row >
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`kpiNameInput`}>KPI Name</label> <br />
              <Input
                type="text"
                className="resource_input9"
                placeholder="KPI Name"
                value={kpiName}
                onChange={(e) => setKpiName(e.target.value)}
                
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`descriptionInput`}>Description</label> <br />
              <Input
                type="text"
                className="resource_input9"
            
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`kpiCategoryInput`}>KPI Category</label> <br />
              <Select
                clearable

                options={selectedOptions}
                selection
                size='mini'
                onChange={handleChange11}
                value={selectedKpiCategory}
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`kpiTypeInput`}>KPI Type</label> <br />
              <Select
                clearable
                options={selectedOptions}
                selection
                size='mini'
                onChange={handleChange12}
                value={selectedKpiType}
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`levelsInput`}>Levels</label> <br />
              <Input
                type="text"
            
                placeholder="Levels"
                className="resource_input9"
                value={levels}
                onChange={(e) => setLevels(e.target.value)}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`dbInput`}>DB</label> <br />
              <Select
                clearable
                selection
                options={db_list}
                isMulti
                size='mini'
                onChange={handleChangeDBs}
                value={selectedDBs}
                hideSelectedOptions={false}
                styles={styles}
                components={{ ValueContainer }}
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`schemasInput`}>Schemas</label> <br />
              
              <Select
                clearable
                selection
                options={schemaslist}
                isMulti
                size='mini'
                onChange={handleChangeSchemas}
                value={selectedSchemas}
                hideSelectedOptions={false}
              styles={styles}
              components={{ ValueContainer }}
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`tablesInput`}>Tables</label> <br />
              <Select
                clearable
                selection
                options={tablelist}
                isMulti
                size='mini'
                onChange={handleChangeTables}
                value={selectedTables}
                hideSelectedOptions={false}
              styles={styles}
              components={{ ValueContainer }}
              />
            </div>
          </Grid.Column>
          <Grid.Column></Grid.Column>
        </Grid.Row>

      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#e9e8d9", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row>
          <Grid.Column></Grid.Column>
          <Grid.Column>
            {selectedDBs && (
              <table id="customers">

                {selectedDBs.map((option) => (
                  <tr key={option.value}>
                    <th>{option.label}</th>
                  </tr>
                ))}

              </table>
            )}

          </Grid.Column>

          <Grid.Column>
            {selectedSchemas && (
              <table id="customers">

                {selectedSchemas.map((option) => (
                  <tr key={option.value}>
                    <th>{option.label}</th>
                  </tr>
                ))}

              </table>
            )}
          </Grid.Column>
          <Grid.Column>
            {selectedTables && (
              <table id="customers">

                {selectedTables.map((option) => (
                  <tr key={option.value}>
                    <th>{option.label}</th>
                  </tr>
                ))}

              </table>
            )}
          </Grid.Column>
          <Grid.Column></Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid columns='equal' divided style={{ backgroundColor: "#e9e8d9", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        {rowData?.map((row, index) => (
          <Grid.Row key={index}>
            <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" htmlFor={`startPositionInput${index}`}>Tables</label> <br />
                <Select
                  clearable
                  options={selectedTables}
                  selection

                  size='mini'
                  value={row.tables || ''}
                  onChange={(e) => saveRow(index, 'tables', e)}

                />
              </div>
            </Grid.Column>

            <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" htmlFor={`identifierTypeInput${index}`}>Columns</label><br />
                <Select
                  text='Identifier'
                  options={columnslist1[index]}
                  value={row.columns || ''}
                  onChange={(e) => saveRow(index, 'columns',e)}

                />
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" htmlFor={`identifierTypeInput${index}`}>Functions</label><br />
                <Select
                  text='Identifier'
                  options={identifier}
                  value={row.functions || ''}
                  onChange={(e) => saveRow(index, 'functions', e)}

                />
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className="form-group ">
                <label className="label1 mb-1" htmlFor={`identifierTypeInput${index}`}>Conditions</label><br />
                <Select
                  text='Identifier'
                  options={identifier}
                  value={row.conditions || ''}
                  onChange={(e) => saveRow(index, 'conditions', e)}

                />
              </div>
            </Grid.Column>
            <Grid.Column></Grid.Column>
          </Grid.Row>

        ))}

        <Grid.Row>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor="prevValueInput">Tables</label><br />
              <Select text='Identifier'
                clearable
                options={selectedTables}
                selection
                size='mini'
                value={formData.tables}
                onChange={(selectedValue) =>
                  handleInputChange({
                    target: { name: 'tables', value: selectedValue },
                  })
                }
              />


            </div>
          </Grid.Column>

          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor="prevValueInput">Columns</label><br />
              <Select text='Identifier' options={columnslist}
                value={formData.columns}
                onChange={(selectedValue) =>
                  handleInputChange({
                    target: { name: 'columns', value: selectedValue },
                  })
                }
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor="prevValueInput">Functions</label><br />
              <Select text='Identifier' options={identifier}
                value={formData.functions}
                onChange={(selectedValue) =>
                  handleInputChange({
                    target: { name: 'functions', value: selectedValue },
                  })
                }
              />
            </div>
          </Grid.Column>

          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor="prevValueInput">Condition</label><br />
              <Select text='Identifier' options={identifier}
                value={formData.conditions}
                onChange={(selectedValue) =>
                  handleInputChange({
                    target: { name: 'conditions', value: selectedValue },
                  })
                }
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <button style={{ height: "35px", width: "92px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em', marginTop: '1.5em' }} onClick={handleAddData}>+</button>
          </Grid.Column>
        </Grid.Row>

      </Grid>


      <Grid item columns='equal' divided style={{ backgroundColor: "#e9e8d9", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`graphTypeInput`}>Graph Type</label> <br />
              <Select
                clearable
                options={identifier}
                selection
                size='mini'
                onChange={handleChangeGraphType}
                value={selectedGraphType}
              />
            </div>
          </Grid.Column>
          <Grid.Column></Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`drilldownInput`}>Drilldown</label> <br />
              <Select
                clearable
                options={selectedOptions}
                selection
                size='mini'
                onChange={handleChangeDrilldown}
                value={selectedDrilldown}
                placeholder='Tables/Graphs'
              />
            </div>
          </Grid.Column>
          <Grid.Column></Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`graphParameterInput`}>Graph Parameter</label> <br />
              <Select
                clearable
                options={identifier}
                selection
                size='mini'
                onChange={handleChangeGraphParameter}
                value={selectedGraphParameter}
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`columnsInput`}>Columns</label> <br />
              <Select
                clearable
                options={identifier}
                selection
                size='mini'
                onChange={handleChangegraphColumns}
                value={selectedgraphColumns}
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`tablesInput`}>Tables</label> <br />
              <Select
                clearable
                options={selectedOptions}
                selection
                size='mini'
                onChange={handleChangedrilldownTables}
                value={selecteddrilldownTables}
              />
            </div>
          </Grid.Column>
          <Grid.Column>
            <div className="form-group ">
              <label className="label1 mb-1" htmlFor={`columnsInput`}>Columns</label> <br />
              <Select
                clearable
                options={selectedOptions}
                selection
                size='mini'
                onChange={handleChangeColumns}
                value={selectedColumns}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>


      <Grid item columns='equal' divided style={{ backgroundColor: "#e9e8d9", paddingLeft: "10px", borderRadius: "15px", margin: '0em' }} className="mt-2 mb-2">
        <Grid.Row>
          <Grid.Column>
            <button style={{ height: "35px", width: "92px", backgroundColor: "#000055", color: "#ffffff", marginLeft: '2em', right: '0' }} onClick={handleSaveData}>Save</button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}

export default KpiNew;
